import React, {
    FC,
    PropsWithChildren,
    useContext,
    useState,
} from 'react';
import { IntlProvider } from '@metsooutotec/modes-react-components';
import translations_en from './translations/en.json';
import translations_fi from './translations/fi.json';

const getTranslations = (locale: string) => {
    switch (locale) {
        case "en": return translations_en;
        case "fi": return translations_fi;
        default: return translations_en;
    }
};

const I18nContext = React.createContext(["", (s: string) => { }]);

export const localeOptions = ["en", "fi"];

export const useCurrentLocale = () => useContext(I18nContext);

export const I18nProvider: FC<PropsWithChildren> = ({ children }) => {
    const [currentLocale, setCurrentLocale] = useState("en");

    return (
        <IntlProvider
            messages={getTranslations(currentLocale)}
            locale={currentLocale}
        >
            <I18nContext.Provider value={[currentLocale, setCurrentLocale]}>
                {children}
            </I18nContext.Provider>
        </IntlProvider>
    );
};
